import { Link } from "react-router-dom";
import { XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBuyGuide } from "@/components/jobbkarta/useBuyGuide";

export default function PaymentCancel() {
  const { buy, loading } = useBuyGuide();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-5 py-10">
      <Link to="/" className="mb-8 font-display text-xl font-extrabold tracking-tight text-slate-900">
        Spontan<span className="text-emerald-600">.</span>
      </Link>
      <div
        data-testid="payment-cancel-card"
        className="w-[min(460px,92vw)] rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-xl"
      >
        <XCircle className="mx-auto h-12 w-12 text-slate-300" />
        <h1 className="mt-4 font-display text-2xl font-extrabold text-slate-900">Köpet avbröts</h1>
        <p className="mt-2 text-sm text-slate-600">
          Ingen betalning gjordes. Du kan prova igen när du vill.
        </p>
        <Button
          onClick={buy}
          disabled={loading}
          data-testid="retry-buy-btn"
          className="mt-6 h-11 w-full gap-2 rounded-full bg-emerald-600 text-base hover:bg-emerald-700"
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          Köp guiden – 89 kr
        </Button>
        <Link to="/" className="mt-4 inline-block text-sm text-slate-500 hover:text-slate-700">
          Tillbaka till start
        </Link>
      </div>
    </div>
  );
}
